<!-- Title -->
<div style="padding: 8px 20px; border-bottom: 2px solid rgb(221, 221, 221); background: rgb(230, 0, 126); color: white; font-weight: bold; border-radius: 8px 8px 0 0">Anzahl der Anmeldungen pro Tag der Woche</div>

<!-- Canvas -->
<div style="background: white; padding: 20px; border-radius: 0 0 8px 8px">
    <canvas style="margin: 20px; margin-bottom: 8px;" id="bar-chart"></canvas>
</div>
